import type { JSX } from "react";

import React from "react";
import { cn } from "../utils/classnames";

// Define a generic function to create error components
function ErrorComponent<T extends keyof JSX.IntrinsicElements>(Component: T) {
  const ComponentFunction = ({
    className,
    children,
    ...props
  }: {
    className?: string;
    children: React.ReactNode;
  } & JSX.IntrinsicElements[T]) =>
    React.createElement(
      Component,
      {
        className: cn("text-sm", className),
        ...props,
      },
      children,
    );

  return ComponentFunction as typeof ComponentFunction & {
    displayName?: string;
  };
}

// Create your components using the factory function
const span = ErrorComponent("span");
const p = ErrorComponent("p");
const label = ErrorComponent("label");

// Set display names for each component
span.displayName = "FormError.span";
p.displayName = "FormError.p";
label.displayName = "FormError.label";

const FormError = {
  label,
  p,
  span,
};

export { FormError };
